import React from 'react';
import { FaTrash } from "react-icons/fa";
import { textTruncate } from "../../../../Utils/utils";
const DeleteFeedbackModal = ({
  isOpen,
  onClose,
  onConfirm,
  feedbackToDelete,
  isDeleting
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
        <div className="mt-3 text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
            <FaTrash className="h-6 w-6 text-red-600" />
          </div>
          <h3 className="text-lg leading-6 font-medium text-gray-900 mt-4">
            Delete Feedback
          </h3>
          <div className="mt-2 px-7 py-3">
            <p className="text-sm text-gray-500">
              Are you sure you want to delete this feedback? This action
              cannot be undone.
            </p>
            {feedbackToDelete && (
              <div className="mt-3 p-3 bg-gray-50 rounded-md">
                <p className="text-sm font-medium text-gray-700">
                  <b>Subject:</b> "<b>{textTruncate(feedbackToDelete?.subject, 20, 10)}</b>"
                </p>
              </div>
            )}
            <p className="text-xs text-gray-500 mt-2">This action will be recorded in the audit log.</p>
          </div>
          <div className="flex justify-center gap-4 mt-4">
            <button
              className={`px-4 py-2 text-gray-800 rounded-md transition-colors ${
                isDeleting
                  ? "bg-gray-200 cursor-not-allowed"
                  : "bg-gray-300 hover:bg-gray-400"
              }`}
              onClick={onClose}
              disabled={isDeleting}
            >
              Cancel
            </button>
            <button
              className={`px-4 py-2 text-white rounded-md transition-colors ${
                isDeleting
                  ? "bg-red-400 cursor-not-allowed"
                  : "bg-red-600 hover:bg-red-700"
              }`}
              onClick={onConfirm}
              disabled={isDeleting}
            >
              {isDeleting ? (
                <span className="flex items-center">
                  <svg
                    className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Deleting...
                </span>
              ) : (
                "Delete"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteFeedbackModal;
